import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campSwNew: FaireAdCampaignEntity = {
  token: "camp_sw_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_strange_water",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 1000,
  startedRunningAt: "2026-05-15",
  segmentMetrics: {
    numCustomersAcquired: 15,
    salesDollars: 2282,
    totalAdsSpendDollars: 697,
    cpaDollars: 46.47,
    bestEstimateSalesDollars: 3452,
    bestEstimateRoas: 4.95,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-29T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
